import moment from 'moment'
import Auth from '@/services/api/Auth'
import ability from '@/plugins/ability'
import * as Sentry from '@sentry/browser'
import Users from '@/services/api/Users'

// initial state
const state = {
  authenticated: false,
  user: null,
  token: null
}

// actions
const actions = {
  login({ commit, dispatch }, { access_token: accessToken, expires_in: expiresIn, user }) {
    if (expiresIn) {
      localStorage.setItem('authToken', accessToken)
      localStorage.setItem('expiresAt', moment().add(expiresIn, 'seconds').unix())
    }
    commit('LOGIN', { token: accessToken, user: user })

    if (!user) {
      dispatch('fetchUserData')
      return
    }

    if (!user.staff || !user.permission_rules) {
      dispatch('logout')
    }

    ability.update(user.permission_rules)

    Sentry.configureScope((scope) => {
      scope.setUser({ id: user.id, username: user.staff ? user.staff.name : undefined, email: user.email })
    })

    dispatch('settings/getBasicData', null, { root: true })
    dispatch('business/getBasicData', null, { root: true })
    dispatch('service/getBasicData', null, { root: true })
  },
  logout({ commit }) {
    localStorage.removeItem('authToken')
    localStorage.removeItem('expiresAt')
    commit('LOGOUT')
  },
  async fetchUserData({ commit, dispatch }) {
    let data = await Auth.fetchOwnData()

    if (!data.staff || !data.permission_rules) {
      dispatch('logout')
    }

    commit('SET_USER_DATA', data)

    Sentry.configureScope((scope) => {
      scope.setUser({ id: data.id, username: data.staff ? data.staff.name : undefined, email: data.email })
    })

    ability.update(data.permission_rules)

    dispatch('settings/getBasicData', null, { root: true })
    dispatch('business/getBasicData', null, { root: true })
    dispatch('service/getBasicData', null, { root: true })
  },
  changeUnits({ commit }, unit) {
    if (unit !== 'metric' && unit !== 'imperial') return

    commit('SET_UNITS', unit)

    Users.updateMe({ units: unit })
  }
}

// mutations
const mutations = {
  LOGIN(state, { token, user }) {
    state.authenticated = true
    state.token = token
    state.user = user
  },
  LOGOUT(state) {
    state.authenticated = false
    state.token = null
    state.user = null
  },
  SET_USER_DATA(state, data) {
    state.user = data
  },
  SET_UNITS(state, unit) {
    if (!state.user) return

    state.user.units = unit
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
